import { motion } from "framer-motion";

const easing = [0.22, 0.61, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.05, margin: "0px 0px -5% 0px" }}
    transition={{ duration: 1, ease: easing, delay }}
    className={className}
  >
    {children}
  </motion.div>
);

export const RevealLine = ({ children, delay = 0, className = "" }) => (
  <span className="inline-block overflow-hidden align-bottom">
    <motion.span
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, amount: 0.01, margin: "0px 0px -2% 0px" }}
      transition={{ duration: 1.1, ease: easing, delay }}
      className={`inline-block ${className}`}
    >
      {children}
    </motion.span>
  </span>
);
